<template>
	<!-- 实名认证 -->
	<div>
		<div class="autonym" v-if="customerDatas.real_status == 1">
			<p>您已通过个人实名认证！</p>
		</div>
		<div class="autonym" v-if="customerDatas.enterprise_new_status == 1">
			<p>您已通过企业实名认证！</p>
		</div>
		<div class="autonym" v-if="customerDatas.real_status == 0">
			<p>您的个人实名认证未通过，原因：{{customerDatas.remark}}</p>
		</div>
		<div class="autonym" v-if="customerDatas.enterprise_new_status == 0">
			<p>您的企业实名认证未通过，原因：{{customerDatas.remark2}}</p>
		</div>
		<div class="autonym" v-if="customerDatas.real_status == 2 || customerDatas.enterprise_new_status == 2">
			<p>您已提交实名认证信息，正在审核中...</p>
		</div>
		<div class="autonym"  v-if="personTab || enterpriseTab"> 
			<div class="autonym_title">
				<span class="auto-tab" :class="{'tab-curr':person}" @click="changeTab('person')" v-if="personTab">个人实名认证</span>
				<span class="auto-tab" :class="{'tab-curr':enterprise}" @click="changeTab('enterprise')" v-if="enterpriseTab">企业实名认证</span>
			</div>
			<span v-show="person">
				<div class="a_center">
					<span class="leftname">真实姓名:</span>
					<input type="text" placeholder="请输入您的真实姓名" class="input" v-model="autonymDatas.names">
				</div>
				<div class="a_center">
					<span class="leftname">身份证号:</span>
					<input type="text" placeholder="请输入您的身份证号" class="input" v-model="autonymDatas.cardId">
				</div>
				<div class="autonym_title">上传照片</div>
				<div class="o_item" v-for="(item,index) in updataImgArr" :key="index">
					<span class="idcard_tit">{{ item.title }}</span>
					<div class="idcard_picture">
						<div class="idcard_sendz" :style="{'backgroundImage':'url(' + updateImg[index].url + ')'}">
							<input type="file" @change="getFile($event,index)" name="ID_card" class="ID_card">
							<p v-if="updateImgShow[index].bool == true" class="reup">点击重新上传</p>
							<img src="@/assets/images/sendpic.png" v-if="updateImgShow[index].bool == false">
							<p v-if="updateImgShow[index].bool == false">{{ item.tipsText }}</p>
						</div>
						<div>
							<img :src="item.rImg">
						</div>
					</div>
				</div>
				<button class="zenbu" @click="postRealName">提交</button>
			</span>
			<span v-show="enterprise">
				<div class="a_center">
					<span class="leftname">营业执照全称:</span>
					<input type="text" placeholder="请输入营业执照全称" class="input" v-model="autonymDatas2.enterprise_name">
				</div>
				<div class="a_center">
					<span class="leftname">统一社会信用代码:</span>
					<input type="text" placeholder="请输入统一社会信用代码" class="input" v-model="autonymDatas2.enterprise_id">
				</div>
				<div class="a_center">
					<span class="leftname">法人姓名:</span>
					<input type="text" placeholder="请输入法人姓名" class="input" v-model="autonymDatas2.enterprise_legal">
				</div>
				<div class="autonym_title">上传照片</div>
				<div class="o_item" v-for="(item,index) in updataImgArr2" :key="index">
					<span class="idcard_tit">{{ item.title }}</span>
					<div class="idcard_picture">
						<div class="idcard_sendz" :style="{'backgroundImage':'url(' + updateImg2[index].url + ')'}">
							<input type="file" @change="getFile2($event,index)" name="ID_card" class="ID_card">
							<p v-if="updateImgShow2[index].bool == true" class="reup">点击重新上传</p>
							<img src="@/assets/images/sendpic.png" v-if="updateImgShow2[index].bool == false">
							<p v-if="updateImgShow2[index].bool == false">{{ item.tipsText }}</p>
						</div>
						<div>
							<img :src="item.rImg">
						</div>
					</div>
				</div>
				<div class="o_item" style="margin-top:20px">
					<span class="idcard_tit">备注:</span>
					<div>
						<textarea placeholder="开户许可证为必填项，如证件丢失，请将开户信息完整的填入到备注中。户名、开户行、开户支行、账号。（户名与营业执照全称一致）" style="width:80%;padding:10px;" class="input" v-model="autonymDatas2.enterprise_remarks"></textarea>
					</div>
				</div>
				<button class="zenbu" @click="postRealName2">提交</button>
			</span>
		</div>
	</div>
</template>

<script>
import qs from 'qs'

export default {
	name: 'Autonym',
	inject: ['reload'],
	data (){
		return{
			token: localStorage.getItem('apiToken'),
			customerDatas: [],
			person: true,
			enterprise: false,
			personTab: true,
			enterpriseTab: true,
			autonymDatas: [
				{names: ''},
				{cardId: ''}
			],
			updataImgArr: [
				{
					title: '*请上传身份证人像图',
					tipsText: '上传身份证人像照片',
					rImg: require('@/assets/images/idcardz.png')
				},
				{
					title: '*请上传身份证国徽图',
					tipsText: '上传身份证国徽照片',
					rImg: require('@/assets/images/idcardf.png')
				},
				{
					title: '*请上传手持身份证图',
					tipsText: '上传手持身份证照片',
					rImg: require('@/assets/images/idcards.png')
				},
				{
					title: '请上传补充材料1（可选）',
					tipsText: '上传补充材料1',
					rImg: require('@/assets/images/idcardy.png')
				},
				{
					title: '请上传补充材料2（可选）',
					tipsText: '上传补充材料2',
					rImg: require('@/assets/images/idcardy.png')
				}
			],
			updateImgShow: [
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false}
			],
			updateImg: [ //实名认证图片信息
				{url:''},
				{url:''},
				{url:''},
				{url:''},
				{url:''},
			],
			autonymDatas2: [
				{enterprise_name: ''},
				{enterprise_id: ''},
				{enterprise_legal: ''},
				{enterprise_remarks: ''},
			],
			updataImgArr2: [
				{
					title: '*请上传营业执照图',
					tipsText: '上传营业执照照片',
					rImg: require('@/assets/images/idcardy.png')
				},
				{
					title: '*请上传法人身份证人像图',
					tipsText: '上传法人身份证人像照片',
					rImg: require('@/assets/images/idcardz.png')
				},
				{
					title: '*请上传法人身份证国徽图',
					tipsText: '上传法人身份证国徽照片',
					rImg: require('@/assets/images/idcardf.png')
				},
				{
					title: '*请上传开户许可证图',
					tipsText: '上传开户许可证照片',
					rImg: require('@/assets/images/idcardy.png')
				},
				{
					title: '请上传补充材料1（可选）',
					tipsText: '上传补充材料1',
					rImg: require('@/assets/images/idcardy.png')
				},
				{
					title: '请上传补充材料2（可选）',
					tipsText: '上传补充材料2',
					rImg: require('@/assets/images/idcardy.png')
				}
			],
			updateImgShow2: [
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false},
				{bool: false}
			],
			updateImg2: [ //实名认证图片信息
				{url:''},
				{url:''},
				{url:''},
				{url:''},
				{url:''},
				{url:''}
			]
		}
	},
	created(){
		this.getCustomer();
	},
	methods: {
		changeTab: function(n) {
			if (n=='person') {
				this.person = true;
				this.enterprise = false;
			} else {
				this.person = false;
				this.enterprise = true;
			}
		},
		// 个人上传图片
		getFile: function(event,index){
			const file = event.target.files[0]
			//请求接口前需要传的参数
			let formData = new FormData()
			formData.append('apiToken', this.token)
			formData.append('file', file)
			this.axios.post(this.$global.apiUrl.upload_file, formData, {
				headers: {
					'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
				}
			})
			.then((response) => {
				if(response.data.error.code == 0){
					this.updateImg[index].url = response.data.url
					this.updateImgShow[index].bool = true
				}
			})
			.catch(() => {})
		},
		// 个人实名认证提交
		postRealName: function(){
			var r = confirm("您确定提交");
			if (r == true){
				let realDatas = qs.stringify({
					name: this.autonymDatas.names,
					cardId: this.autonymDatas.cardId,
					cardImgF: this.updateImg[0].url,
					cardImgB: this.updateImg[1].url,
					cardImgH: this.updateImg[2].url,
					img1: this.updateImg[3].url,
					img2: this.updateImg[4].url,
					apiToken: this.token,
					type: 'person',
				})
				this.axios.post(this.$global.apiUrl.customer_real, realDatas, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
				.then((response) => {
					if (response.data.error.code == 0){
						this.$alert('提交成功，请耐心等待审核', '提示', {
							confirmButtonText: '确定'
						});
						this.getCustomer();
					}else{
						this.$alert(response.data.error.message, '提示', {
							confirmButtonText: '确定'
						});
					}
				})
				.catch(() => {})
			}
		},
		// 企业上传图片
		getFile2: function(event,index){
			const file = event.target.files[0]
			//请求接口前需要传的参数
			let formData = new FormData()
			formData.append('apiToken', this.token)
			formData.append('file', file)
			this.axios.post(this.$global.apiUrl.upload_file, formData, {
				headers: {
					'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime()
				}
			})
			.then((response) => {
				if(response.data.error.code == 0){
					this.updateImg2[index].url = response.data.url
					this.updateImgShow2[index].bool = true
				}
			})
			.catch(() => {})
		},
		// 企业实名认证提交
		postRealName2: function(){
			var r = confirm("您确定提交");
			if (r == true){
				let realDatas = qs.stringify({
					name: this.autonymDatas2.enterprise_name,
					cardId: this.autonymDatas2.enterprise_id,
					enterprise_legal: this.autonymDatas2.enterprise_legal,
					enterprise_remarks: this.autonymDatas2.enterprise_remarks,
					enterprise_img_busness: this.updateImg2[0].url,
					enterprise_img_cardF: this.updateImg2[1].url,
					enterprise_img_cardB: this.updateImg2[2].url,
					enterprise_img_license: this.updateImg2[3].url,
					img1: this.updateImg2[4].url,
					img2: this.updateImg2[5].url,
					apiToken: this.token,
					type: 'enterprise',
				})
				this.axios.post(this.$global.apiUrl.customer_real, realDatas, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
				.then((response) => {
					if (response.data.error.code == 0){
						this.$alert('提交成功，请耐心等待审核', '提示', {
							confirmButtonText: '确定'
						});
						this.getCustomer();
					}else{
						this.$alert(response.data.error.message, '提示', {
							confirmButtonText: '确定'
						});
					}
				})
				.catch(() => {})
			}
		},
		getCustomer: function(){
			// 请求个人资料数据
			this.axios.get(this.$global.apiUrl.customer, {
				params: {
					apiToken: this.token
				}
			})
			.then((response) => {
				if(response.data.error.code == 0){
					this.customerDatas = response.data.customer;
					
					this.autonymDatas.names = response.data.customer.name;
					this.autonymDatas.cardId = response.data.customer.card_id;
					this.updateImg[0].url = response.data.customer.card_img_f;
					this.updateImg[1].url = response.data.customer.card_img_b;
					this.updateImg[2].url = response.data.customer.card_img_h;
					this.updateImg[3].url = response.data.customer.img1;
					this.updateImg[4].url = response.data.customer.img2;
					if (this.updateImg[0].url!='') this.updateImgShow[0].bool=true;
					if (this.updateImg[1].url!='') this.updateImgShow[1].bool=true;
					if (this.updateImg[2].url!='') this.updateImgShow[2].bool=true;
					if (this.updateImg[3].url!='') this.updateImgShow[3].bool=true;
					if (this.updateImg[4].url!='') this.updateImgShow[4].bool=true;
					this.autonymDatas2.enterprise_name = response.data.customer.name;
					this.autonymDatas2.enterprise_id = response.data.customer.card_id;
					this.autonymDatas2.enterprise_legal = response.data.customer.enterprise_legal;
					this.autonymDatas2.enterprise_remarks = response.data.customer.enterprise_remarks;
					this.updateImg2[0].url = response.data.customer.enterprise_img_busness;
					this.updateImg2[1].url = response.data.customer.enterprise_img_cardF;
					this.updateImg2[2].url = response.data.customer.enterprise_img_cardB;
					this.updateImg2[3].url = response.data.customer.enterprise_img_license;
					this.updateImg2[4].url = response.data.customer.img1;
					this.updateImg2[5].url = response.data.customer.img2;
					if (this.updateImg2[0].url!='') this.updateImgShow2[0].bool=true;
					if (this.updateImg2[1].url!='') this.updateImgShow2[1].bool=true;
					if (this.updateImg2[2].url!='') this.updateImgShow2[2].bool=true;
					if (this.updateImg2[3].url!='') this.updateImgShow2[3].bool=true;
					if (this.updateImg2[4].url!='') this.updateImgShow2[4].bool=true;
					if (this.updateImg2[5].url!='') this.updateImgShow2[5].bool=true;

					if (response.data.customer.real_status == 1 || response.data.customer.enterprise_new_status == 1) {
						this.personTab = false;
						this.person = false;
						this.enterpriseTab = false;
						this.enterprise = false;
					}
					if (response.data.customer.real_status == 2 || response.data.customer.enterprise_new_status == 2) {
						this.personTab = false;
						this.enterpriseTab = false;
						this.person = false;
						this.enterprise = false;
					}
				}
			})
			.catch(() => {})
		}
	}
}
</script>
<style scoped>
.auto-tab {
	cursor: pointer;
	padding: 0 10px;
	font-size: 12px;
}
.tab-curr {
	font-size: 16px;
	color:#c71622;
}
</style>